//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const SERVICES_DMS_API_BASE_URL = new InjectionToken<string>('SERVICES_DMS_API_BASE_URL');

export interface IServicesDmsApiService {
    /**
     * Get available document options per service type
     * @return OK
     */
    getDocumentOptions(serviceType: string): Observable<ServiceDocumentsResponse>;
    /**
     * Get documents by criteria
     * @param categories (optional) 
     * @return OK
     */
    getDocuments(idOrCode: string, queryType: string, categories?: DocumentCategory[] | undefined): Observable<DocumentResultSet>;
    /**
     * Delete document
     * @return No Content
     */
    deleteDocument(documentCategory: string, documentId: string): Observable<void>;
    /**
     * Download document
     * @return OK
     */
    downloadDocument(documentCategory: string, documentId: string): Observable<FileResponse>;
    /**
     * Updates document file
     * @param file (optional) 
     * @return OK
     */
    updateDocumentFile(documentCategory: string, documentId: string, file?: FileParameter | null | undefined): Observable<Document>;
    /**
     * Delete document's metadata
     * @return No Content
     */
    deleteDocumentMetadata(documentCategory: string, documentId: string, body: DocumentDeleteMetadataRequest): Observable<void>;
    /**
     * Upsert document's metadata
     * @return No Content
     */
    updateDocumentMetadata(documentCategory: string, documentId: string, sendNotification: boolean, body: BaseDocumentRequest): Observable<void>;
    /**
     * Get my property documents
     * @param categories (optional) 
     * @return OK
     */
    getMyPropertyDocuments(propertyId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]>;
    /**
     * Get my requests documents
     * @param categories (optional) 
     * @return OK
     */
    getMyRequestsDocuments(requestId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]>;
    /**
     * Upload property's document
     * @param userId (optional) 
     * @param customerTaxCode (optional) 
     * @param relatedPropertyCode (optional) 
     * @param relatedPropertyId (optional) 
     * @param relatedPropertyRn (optional) 
     * @param kaek (optional) 
     * @param relatedPropertyType (optional) 
     * @param streetName (optional) 
     * @param streetNumber (optional) 
     * @param city (optional) 
     * @param postalCode (optional) 
     * @param sdenApplicationNo (optional) 
     * @param loanAggreementNo (optional) 
     * @param almaNo (optional) 
     * @param forLawyer (optional) 
     * @param forEngineer (optional) 
     * @param isActive (optional) 
     * @param writingYear (optional) 
     * @param issueDate (optional) 
     * @param customerFullName (optional) 
     * @param comment (optional) 
     * @param status (optional) 
     * @param createdBy (optional) 
     * @param updatedBy (optional) 
     * @param category (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadAssetDocumentFile(propertyId: string, userId?: string | null | undefined, customerTaxCode?: string | null | undefined, relatedPropertyCode?: string | null | undefined, relatedPropertyId?: string | null | undefined, relatedPropertyRn?: string | null | undefined, kaek?: number | null | undefined, relatedPropertyType?: string | null | undefined, streetName?: string | null | undefined, streetNumber?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, sdenApplicationNo?: string | null | undefined, loanAggreementNo?: string | null | undefined, almaNo?: string | null | undefined, forLawyer?: boolean | null | undefined, forEngineer?: boolean | null | undefined, isActive?: boolean | null | undefined, writingYear?: number | null | undefined, issueDate?: Date | null | undefined, customerFullName?: string | null | undefined, comment?: string | null | undefined, status?: DocumentStatus | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, category?: DocumentCategory | undefined, file?: FileParameter | null | undefined): Observable<Document>;
    /**
     * Get property documents
     * @param categories (optional) 
     * @return OK
     */
    getPropertyDocuments(propertyId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]>;
    /**
     * Creates property folder if it doesn't already exist
     * @return OK
     */
    createPropertyFolder(body: CreateFolderRequest): Observable<SearchFolderResponse>;
    /**
     * Upload request's document
     * @param userId (optional) 
     * @param customerTaxCode (optional) 
     * @param relatedPropertyCode (optional) 
     * @param relatedPropertyId (optional) 
     * @param relatedPropertyRn (optional) 
     * @param kaek (optional) 
     * @param relatedPropertyType (optional) 
     * @param streetName (optional) 
     * @param streetNumber (optional) 
     * @param city (optional) 
     * @param postalCode (optional) 
     * @param sdenApplicationNo (optional) 
     * @param loanAggreementNo (optional) 
     * @param almaNo (optional) 
     * @param forLawyer (optional) 
     * @param forEngineer (optional) 
     * @param isActive (optional) 
     * @param writingYear (optional) 
     * @param issueDate (optional) 
     * @param customerFullName (optional) 
     * @param comment (optional) 
     * @param status (optional) 
     * @param createdBy (optional) 
     * @param updatedBy (optional) 
     * @param category (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadRequestDocumentFile(requestId: string, userId?: string | null | undefined, customerTaxCode?: string | null | undefined, relatedPropertyCode?: string | null | undefined, relatedPropertyId?: string | null | undefined, relatedPropertyRn?: string | null | undefined, kaek?: number | null | undefined, relatedPropertyType?: string | null | undefined, streetName?: string | null | undefined, streetNumber?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, sdenApplicationNo?: string | null | undefined, loanAggreementNo?: string | null | undefined, almaNo?: string | null | undefined, forLawyer?: boolean | null | undefined, forEngineer?: boolean | null | undefined, isActive?: boolean | null | undefined, writingYear?: number | null | undefined, issueDate?: Date | null | undefined, customerFullName?: string | null | undefined, comment?: string | null | undefined, status?: DocumentStatus | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, category?: DocumentCategory | undefined, file?: FileParameter | null | undefined): Observable<Document>;
    /**
     * Get request documents
     * @param categories (optional) 
     * @return OK
     */
    getRequestDocuments(requestId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]>;
    /**
     * Creates request folder if it doesn't already exist
     * @return OK
     */
    createRequestFolder(body: CreateFolderRequest): Observable<SearchFolderResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ServicesDmsApiService implements IServicesDmsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SERVICES_DMS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get available document options per service type
     * @return OK
     */
    getDocumentOptions(serviceType: string): Observable<ServiceDocumentsResponse> {
        let url_ = this.baseUrl + "/document-options/{serviceType}";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined.");
        url_ = url_.replace("{serviceType}", encodeURIComponent("" + serviceType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDocumentsResponse>;
        }));
    }

    protected processGetDocumentOptions(response: HttpResponseBase): Observable<ServiceDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get documents by criteria
     * @param categories (optional) 
     * @return OK
     */
    getDocuments(idOrCode: string, queryType: string, categories?: DocumentCategory[] | undefined): Observable<DocumentResultSet> {
        let url_ = this.baseUrl + "/documents?";
        if (idOrCode === undefined || idOrCode === null)
            throw new Error("The parameter 'idOrCode' must be defined and cannot be null.");
        else
            url_ += "IdOrCode=" + encodeURIComponent("" + idOrCode) + "&";
        if (queryType === undefined || queryType === null)
            throw new Error("The parameter 'queryType' must be defined and cannot be null.");
        else
            url_ += "QueryType=" + encodeURIComponent("" + queryType) + "&";
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResultSet>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete document
     * @return No Content
     */
    deleteDocument(documentCategory: string, documentId: string): Observable<void> {
        let url_ = this.baseUrl + "/documents/{documentCategory}/{documentId}";
        if (documentCategory === undefined || documentCategory === null)
            throw new Error("The parameter 'documentCategory' must be defined.");
        url_ = url_.replace("{documentCategory}", encodeURIComponent("" + documentCategory));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download document
     * @return OK
     */
    downloadDocument(documentCategory: string, documentId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/documents/{documentCategory}/{documentId}";
        if (documentCategory === undefined || documentCategory === null)
            throw new Error("The parameter 'documentCategory' must be defined.");
        url_ = url_.replace("{documentCategory}", encodeURIComponent("" + documentCategory));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates document file
     * @param file (optional) 
     * @return OK
     */
    updateDocumentFile(documentCategory: string, documentId: string, file?: FileParameter | null | undefined): Observable<Document> {
        let url_ = this.baseUrl + "/documents/{documentCategory}/{documentId}";
        if (documentCategory === undefined || documentCategory === null)
            throw new Error("The parameter 'documentCategory' must be defined.");
        url_ = url_.replace("{documentCategory}", encodeURIComponent("" + documentCategory));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document>;
        }));
    }

    protected processUpdateDocumentFile(response: HttpResponseBase): Observable<Document> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Document.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete document's metadata
     * @return No Content
     */
    deleteDocumentMetadata(documentCategory: string, documentId: string, body: DocumentDeleteMetadataRequest): Observable<void> {
        let url_ = this.baseUrl + "/documents/{documentCategory}/{documentId}/metadata";
        if (documentCategory === undefined || documentCategory === null)
            throw new Error("The parameter 'documentCategory' must be defined.");
        url_ = url_.replace("{documentCategory}", encodeURIComponent("" + documentCategory));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocumentMetadata(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upsert document's metadata
     * @return No Content
     */
    updateDocumentMetadata(documentCategory: string, documentId: string, sendNotification: boolean, body: BaseDocumentRequest): Observable<void> {
        let url_ = this.baseUrl + "/documents/{documentCategory}/{documentId}/metadata?";
        if (documentCategory === undefined || documentCategory === null)
            throw new Error("The parameter 'documentCategory' must be defined.");
        url_ = url_.replace("{documentCategory}", encodeURIComponent("" + documentCategory));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (sendNotification === undefined || sendNotification === null)
            throw new Error("The parameter 'sendNotification' must be defined and cannot be null.");
        else
            url_ += "sendNotification=" + encodeURIComponent("" + sendNotification) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDocumentMetadata(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get my property documents
     * @param categories (optional) 
     * @return OK
     */
    getMyPropertyDocuments(propertyId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]> {
        let url_ = this.baseUrl + "/my/properties/{propertyId}/documents?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyPropertyDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyPropertyDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processGetMyPropertyDocuments(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get my requests documents
     * @param categories (optional) 
     * @return OK
     */
    getMyRequestsDocuments(requestId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]> {
        let url_ = this.baseUrl + "/my/requests/{requestId}/documents?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRequestsDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRequestsDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processGetMyRequestsDocuments(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload property's document
     * @param userId (optional) 
     * @param customerTaxCode (optional) 
     * @param relatedPropertyCode (optional) 
     * @param relatedPropertyId (optional) 
     * @param relatedPropertyRn (optional) 
     * @param kaek (optional) 
     * @param relatedPropertyType (optional) 
     * @param streetName (optional) 
     * @param streetNumber (optional) 
     * @param city (optional) 
     * @param postalCode (optional) 
     * @param sdenApplicationNo (optional) 
     * @param loanAggreementNo (optional) 
     * @param almaNo (optional) 
     * @param forLawyer (optional) 
     * @param forEngineer (optional) 
     * @param isActive (optional) 
     * @param writingYear (optional) 
     * @param issueDate (optional) 
     * @param customerFullName (optional) 
     * @param comment (optional) 
     * @param status (optional) 
     * @param createdBy (optional) 
     * @param updatedBy (optional) 
     * @param category (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadAssetDocumentFile(propertyId: string, userId?: string | null | undefined, customerTaxCode?: string | null | undefined, relatedPropertyCode?: string | null | undefined, relatedPropertyId?: string | null | undefined, relatedPropertyRn?: string | null | undefined, kaek?: number | null | undefined, relatedPropertyType?: string | null | undefined, streetName?: string | null | undefined, streetNumber?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, sdenApplicationNo?: string | null | undefined, loanAggreementNo?: string | null | undefined, almaNo?: string | null | undefined, forLawyer?: boolean | null | undefined, forEngineer?: boolean | null | undefined, isActive?: boolean | null | undefined, writingYear?: number | null | undefined, issueDate?: Date | null | undefined, customerFullName?: string | null | undefined, comment?: string | null | undefined, status?: DocumentStatus | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, category?: DocumentCategory | undefined, file?: FileParameter | null | undefined): Observable<Document> {
        let url_ = this.baseUrl + "/properties/{propertyId}/documents";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userId !== null && userId !== undefined)
            content_.append("userId", userId.toString());
        if (customerTaxCode !== null && customerTaxCode !== undefined)
            content_.append("customerTaxCode", customerTaxCode.toString());
        if (relatedPropertyCode !== null && relatedPropertyCode !== undefined)
            content_.append("relatedPropertyCode", relatedPropertyCode.toString());
        if (relatedPropertyId !== null && relatedPropertyId !== undefined)
            content_.append("relatedPropertyId", relatedPropertyId.toString());
        if (relatedPropertyRn !== null && relatedPropertyRn !== undefined)
            content_.append("relatedPropertyRn", relatedPropertyRn.toString());
        if (kaek !== null && kaek !== undefined)
            content_.append("kaek", kaek.toString());
        if (relatedPropertyType !== null && relatedPropertyType !== undefined)
            content_.append("relatedPropertyType", relatedPropertyType.toString());
        if (streetName !== null && streetName !== undefined)
            content_.append("streetName", streetName.toString());
        if (streetNumber !== null && streetNumber !== undefined)
            content_.append("streetNumber", streetNumber.toString());
        if (city !== null && city !== undefined)
            content_.append("city", city.toString());
        if (postalCode !== null && postalCode !== undefined)
            content_.append("postalCode", postalCode.toString());
        if (sdenApplicationNo !== null && sdenApplicationNo !== undefined)
            content_.append("sdenApplicationNo", sdenApplicationNo.toString());
        if (loanAggreementNo !== null && loanAggreementNo !== undefined)
            content_.append("loanAggreementNo", loanAggreementNo.toString());
        if (almaNo !== null && almaNo !== undefined)
            content_.append("almaNo", almaNo.toString());
        if (forLawyer !== null && forLawyer !== undefined)
            content_.append("forLawyer", forLawyer.toString());
        if (forEngineer !== null && forEngineer !== undefined)
            content_.append("forEngineer", forEngineer.toString());
        if (isActive !== null && isActive !== undefined)
            content_.append("isActive", isActive.toString());
        if (writingYear !== null && writingYear !== undefined)
            content_.append("writingYear", writingYear.toString());
        if (issueDate !== null && issueDate !== undefined)
            content_.append("issueDate", issueDate.toJSON());
        if (customerFullName !== null && customerFullName !== undefined)
            content_.append("customerFullName", customerFullName.toString());
        if (comment !== null && comment !== undefined)
            content_.append("comment", comment.toString());
        if (status !== null && status !== undefined)
            content_.append("status", status.toString());
        if (createdBy !== null && createdBy !== undefined)
            content_.append("createdBy", createdBy.toString());
        if (updatedBy !== null && updatedBy !== undefined)
            content_.append("updatedBy", updatedBy.toString());
        if (category === null || category === undefined)
            throw new Error("The parameter 'category' cannot be null.");
        else
            content_.append("category", category.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAssetDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAssetDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document>;
        }));
    }

    protected processUploadAssetDocumentFile(response: HttpResponseBase): Observable<Document> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Document.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get property documents
     * @param categories (optional) 
     * @return OK
     */
    getPropertyDocuments(propertyId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]> {
        let url_ = this.baseUrl + "/properties/{propertyId}/documents?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPropertyDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPropertyDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processGetPropertyDocuments(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates property folder if it doesn't already exist
     * @return OK
     */
    createPropertyFolder(body: CreateFolderRequest): Observable<SearchFolderResponse> {
        let url_ = this.baseUrl + "/properties/folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePropertyFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePropertyFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFolderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFolderResponse>;
        }));
    }

    protected processCreatePropertyFolder(response: HttpResponseBase): Observable<SearchFolderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFolderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Upload request's document
     * @param userId (optional) 
     * @param customerTaxCode (optional) 
     * @param relatedPropertyCode (optional) 
     * @param relatedPropertyId (optional) 
     * @param relatedPropertyRn (optional) 
     * @param kaek (optional) 
     * @param relatedPropertyType (optional) 
     * @param streetName (optional) 
     * @param streetNumber (optional) 
     * @param city (optional) 
     * @param postalCode (optional) 
     * @param sdenApplicationNo (optional) 
     * @param loanAggreementNo (optional) 
     * @param almaNo (optional) 
     * @param forLawyer (optional) 
     * @param forEngineer (optional) 
     * @param isActive (optional) 
     * @param writingYear (optional) 
     * @param issueDate (optional) 
     * @param customerFullName (optional) 
     * @param comment (optional) 
     * @param status (optional) 
     * @param createdBy (optional) 
     * @param updatedBy (optional) 
     * @param category (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadRequestDocumentFile(requestId: string, userId?: string | null | undefined, customerTaxCode?: string | null | undefined, relatedPropertyCode?: string | null | undefined, relatedPropertyId?: string | null | undefined, relatedPropertyRn?: string | null | undefined, kaek?: number | null | undefined, relatedPropertyType?: string | null | undefined, streetName?: string | null | undefined, streetNumber?: string | null | undefined, city?: string | null | undefined, postalCode?: string | null | undefined, sdenApplicationNo?: string | null | undefined, loanAggreementNo?: string | null | undefined, almaNo?: string | null | undefined, forLawyer?: boolean | null | undefined, forEngineer?: boolean | null | undefined, isActive?: boolean | null | undefined, writingYear?: number | null | undefined, issueDate?: Date | null | undefined, customerFullName?: string | null | undefined, comment?: string | null | undefined, status?: DocumentStatus | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, category?: DocumentCategory | undefined, file?: FileParameter | null | undefined): Observable<Document> {
        let url_ = this.baseUrl + "/requests/{requestId}/documents";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userId !== null && userId !== undefined)
            content_.append("userId", userId.toString());
        if (customerTaxCode !== null && customerTaxCode !== undefined)
            content_.append("customerTaxCode", customerTaxCode.toString());
        if (relatedPropertyCode !== null && relatedPropertyCode !== undefined)
            content_.append("relatedPropertyCode", relatedPropertyCode.toString());
        if (relatedPropertyId !== null && relatedPropertyId !== undefined)
            content_.append("relatedPropertyId", relatedPropertyId.toString());
        if (relatedPropertyRn !== null && relatedPropertyRn !== undefined)
            content_.append("relatedPropertyRn", relatedPropertyRn.toString());
        if (kaek !== null && kaek !== undefined)
            content_.append("kaek", kaek.toString());
        if (relatedPropertyType !== null && relatedPropertyType !== undefined)
            content_.append("relatedPropertyType", relatedPropertyType.toString());
        if (streetName !== null && streetName !== undefined)
            content_.append("streetName", streetName.toString());
        if (streetNumber !== null && streetNumber !== undefined)
            content_.append("streetNumber", streetNumber.toString());
        if (city !== null && city !== undefined)
            content_.append("city", city.toString());
        if (postalCode !== null && postalCode !== undefined)
            content_.append("postalCode", postalCode.toString());
        if (sdenApplicationNo !== null && sdenApplicationNo !== undefined)
            content_.append("sdenApplicationNo", sdenApplicationNo.toString());
        if (loanAggreementNo !== null && loanAggreementNo !== undefined)
            content_.append("loanAggreementNo", loanAggreementNo.toString());
        if (almaNo !== null && almaNo !== undefined)
            content_.append("almaNo", almaNo.toString());
        if (forLawyer !== null && forLawyer !== undefined)
            content_.append("forLawyer", forLawyer.toString());
        if (forEngineer !== null && forEngineer !== undefined)
            content_.append("forEngineer", forEngineer.toString());
        if (isActive !== null && isActive !== undefined)
            content_.append("isActive", isActive.toString());
        if (writingYear !== null && writingYear !== undefined)
            content_.append("writingYear", writingYear.toString());
        if (issueDate !== null && issueDate !== undefined)
            content_.append("issueDate", issueDate.toJSON());
        if (customerFullName !== null && customerFullName !== undefined)
            content_.append("customerFullName", customerFullName.toString());
        if (comment !== null && comment !== undefined)
            content_.append("comment", comment.toString());
        if (status !== null && status !== undefined)
            content_.append("status", status.toString());
        if (createdBy !== null && createdBy !== undefined)
            content_.append("createdBy", createdBy.toString());
        if (updatedBy !== null && updatedBy !== undefined)
            content_.append("updatedBy", updatedBy.toString());
        if (category === null || category === undefined)
            throw new Error("The parameter 'category' cannot be null.");
        else
            content_.append("category", category.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadRequestDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadRequestDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document>;
        }));
    }

    protected processUploadRequestDocumentFile(response: HttpResponseBase): Observable<Document> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Document.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get request documents
     * @param categories (optional) 
     * @return OK
     */
    getRequestDocuments(requestId: string, categories?: DocumentCategory[] | undefined): Observable<Document[]> {
        let url_ = this.baseUrl + "/requests/{requestId}/documents?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        if (categories === null)
            throw new Error("The parameter 'categories' cannot be null.");
        else if (categories !== undefined)
            categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Document[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Document[]>;
        }));
    }

    protected processGetRequestDocuments(response: HttpResponseBase): Observable<Document[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Document.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates request folder if it doesn't already exist
     * @return OK
     */
    createRequestFolder(body: CreateFolderRequest): Observable<SearchFolderResponse> {
        let url_ = this.baseUrl + "/requests/folder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRequestFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRequestFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchFolderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchFolderResponse>;
        }));
    }

    protected processCreateRequestFolder(response: HttpResponseBase): Observable<SearchFolderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchFolderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class BaseDocumentRequest implements IBaseDocumentRequest {
    userId?: string | undefined;
    customerTaxCode?: string | undefined;
    relatedPropertyCode?: string | undefined;
    relatedPropertyId?: string | undefined;
    relatedPropertyRn?: string | undefined;
    kaek?: number | undefined;
    relatedPropertyType?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    sdenApplicationNo?: string | undefined;
    loanAggreementNo?: string | undefined;
    almaNo?: string | undefined;
    forLawyer?: boolean | undefined;
    forEngineer?: boolean | undefined;
    isActive?: boolean | undefined;
    writingYear?: number | undefined;
    issueDate?: Date | undefined;
    customerFullName?: string | undefined;
    comment?: string | undefined;
    status?: DocumentStatus | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IBaseDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.customerTaxCode = _data["customerTaxCode"];
            this.relatedPropertyCode = _data["relatedPropertyCode"];
            this.relatedPropertyId = _data["relatedPropertyId"];
            this.relatedPropertyRn = _data["relatedPropertyRn"];
            this.kaek = _data["kaek"];
            this.relatedPropertyType = _data["relatedPropertyType"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.sdenApplicationNo = _data["sdenApplicationNo"];
            this.loanAggreementNo = _data["loanAggreementNo"];
            this.almaNo = _data["almaNo"];
            this.forLawyer = _data["forLawyer"];
            this.forEngineer = _data["forEngineer"];
            this.isActive = _data["isActive"];
            this.writingYear = _data["writingYear"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.customerFullName = _data["customerFullName"];
            this.comment = _data["comment"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): BaseDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BaseDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["customerTaxCode"] = this.customerTaxCode;
        data["relatedPropertyCode"] = this.relatedPropertyCode;
        data["relatedPropertyId"] = this.relatedPropertyId;
        data["relatedPropertyRn"] = this.relatedPropertyRn;
        data["kaek"] = this.kaek;
        data["relatedPropertyType"] = this.relatedPropertyType;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["sdenApplicationNo"] = this.sdenApplicationNo;
        data["loanAggreementNo"] = this.loanAggreementNo;
        data["almaNo"] = this.almaNo;
        data["forLawyer"] = this.forLawyer;
        data["forEngineer"] = this.forEngineer;
        data["isActive"] = this.isActive;
        data["writingYear"] = this.writingYear;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["customerFullName"] = this.customerFullName;
        data["comment"] = this.comment;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IBaseDocumentRequest {
    userId?: string | undefined;
    customerTaxCode?: string | undefined;
    relatedPropertyCode?: string | undefined;
    relatedPropertyId?: string | undefined;
    relatedPropertyRn?: string | undefined;
    kaek?: number | undefined;
    relatedPropertyType?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    sdenApplicationNo?: string | undefined;
    loanAggreementNo?: string | undefined;
    almaNo?: string | undefined;
    forLawyer?: boolean | undefined;
    forEngineer?: boolean | undefined;
    isActive?: boolean | undefined;
    writingYear?: number | undefined;
    issueDate?: Date | undefined;
    customerFullName?: string | undefined;
    comment?: string | undefined;
    status?: DocumentStatus | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
}

export class BooleanMetadataConfig implements IBooleanMetadataConfig {
    valueNotAvailable?: DocumentCategory[] | undefined;
    valueTrue?: DocumentCategory[] | undefined;
    valueFalse?: DocumentCategory[] | undefined;

    constructor(data?: IBooleanMetadataConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["valueNotAvailable"])) {
                this.valueNotAvailable = [] as any;
                for (let item of _data["valueNotAvailable"])
                    this.valueNotAvailable!.push(item);
            }
            if (Array.isArray(_data["valueTrue"])) {
                this.valueTrue = [] as any;
                for (let item of _data["valueTrue"])
                    this.valueTrue!.push(item);
            }
            if (Array.isArray(_data["valueFalse"])) {
                this.valueFalse = [] as any;
                for (let item of _data["valueFalse"])
                    this.valueFalse!.push(item);
            }
        }
    }

    static fromJS(data: any): BooleanMetadataConfig {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanMetadataConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.valueNotAvailable)) {
            data["valueNotAvailable"] = [];
            for (let item of this.valueNotAvailable)
                data["valueNotAvailable"].push(item);
        }
        if (Array.isArray(this.valueTrue)) {
            data["valueTrue"] = [];
            for (let item of this.valueTrue)
                data["valueTrue"].push(item);
        }
        if (Array.isArray(this.valueFalse)) {
            data["valueFalse"] = [];
            for (let item of this.valueFalse)
                data["valueFalse"].push(item);
        }
        return data;
    }
}

export interface IBooleanMetadataConfig {
    valueNotAvailable?: DocumentCategory[] | undefined;
    valueTrue?: DocumentCategory[] | undefined;
    valueFalse?: DocumentCategory[] | undefined;
}

export class CreateFolderRequest implements ICreateFolderRequest {
    id?: string;

    constructor(data?: ICreateFolderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateFolderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFolderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateFolderRequest {
    id?: string;
}

export class DigitalDocumentInfo implements IDigitalDocumentInfo {
    id?: string | undefined;
    version?: number | undefined;
    versionEndUser?: string | undefined;
    versionEndUserName?: string | undefined;
    versionBranch?: string | undefined;
    versionTime?: Date | undefined;
    configurationItem?: string;
    configurationItemName?: string | undefined;
    configurationSubItem?: string;
    configurationSubItemName?: string | undefined;
    customer?: number | undefined;
    customerName?: string | undefined;
    additionalCustomers?: number[] | undefined;
    creationDate?: Date | undefined;

    [key: string]: any;

    constructor(data?: IDigitalDocumentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.version = _data["version"];
            this.versionEndUser = _data["versionEndUser"];
            this.versionEndUserName = _data["versionEndUserName"];
            this.versionBranch = _data["versionBranch"];
            this.versionTime = _data["versionTime"] ? new Date(_data["versionTime"].toString()) : <any>undefined;
            this.configurationItem = _data["configurationItem"];
            this.configurationItemName = _data["configurationItemName"];
            this.configurationSubItem = _data["configurationSubItem"];
            this.configurationSubItemName = _data["configurationSubItemName"];
            this.customer = _data["customer"];
            this.customerName = _data["customerName"];
            if (Array.isArray(_data["additionalCustomers"])) {
                this.additionalCustomers = [] as any;
                for (let item of _data["additionalCustomers"])
                    this.additionalCustomers!.push(item);
            }
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DigitalDocumentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DigitalDocumentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["version"] = this.version;
        data["versionEndUser"] = this.versionEndUser;
        data["versionEndUserName"] = this.versionEndUserName;
        data["versionBranch"] = this.versionBranch;
        data["versionTime"] = this.versionTime ? this.versionTime.toISOString() : <any>undefined;
        data["configurationItem"] = this.configurationItem;
        data["configurationItemName"] = this.configurationItemName;
        data["configurationSubItem"] = this.configurationSubItem;
        data["configurationSubItemName"] = this.configurationSubItemName;
        data["customer"] = this.customer;
        data["customerName"] = this.customerName;
        if (Array.isArray(this.additionalCustomers)) {
            data["additionalCustomers"] = [];
            for (let item of this.additionalCustomers)
                data["additionalCustomers"].push(item);
        }
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDigitalDocumentInfo {
    id?: string | undefined;
    version?: number | undefined;
    versionEndUser?: string | undefined;
    versionEndUserName?: string | undefined;
    versionBranch?: string | undefined;
    versionTime?: Date | undefined;
    configurationItem?: string;
    configurationItemName?: string | undefined;
    configurationSubItem?: string;
    configurationSubItemName?: string | undefined;
    customer?: number | undefined;
    customerName?: string | undefined;
    additionalCustomers?: number[] | undefined;
    creationDate?: Date | undefined;

    [key: string]: any;
}

export class DigitalFolderAttributeValues implements IDigitalFolderAttributeValues {
    stringValue?: string | undefined;
    boolValue?: boolean | undefined;
    datetimeValue?: Date | undefined;
    decimalValue?: number | undefined;
    guidValue?: string | undefined;

    [key: string]: any;

    constructor(data?: IDigitalFolderAttributeValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.stringValue = _data["stringValue"];
            this.boolValue = _data["boolValue"];
            this.datetimeValue = _data["datetimeValue"] ? new Date(_data["datetimeValue"].toString()) : <any>undefined;
            this.decimalValue = _data["decimalValue"];
            this.guidValue = _data["guidValue"];
        }
    }

    static fromJS(data: any): DigitalFolderAttributeValues {
        data = typeof data === 'object' ? data : {};
        let result = new DigitalFolderAttributeValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["stringValue"] = this.stringValue;
        data["boolValue"] = this.boolValue;
        data["datetimeValue"] = this.datetimeValue ? this.datetimeValue.toISOString() : <any>undefined;
        data["decimalValue"] = this.decimalValue;
        data["guidValue"] = this.guidValue;
        return data;
    }
}

export interface IDigitalFolderAttributeValues {
    stringValue?: string | undefined;
    boolValue?: boolean | undefined;
    datetimeValue?: Date | undefined;
    decimalValue?: number | undefined;
    guidValue?: string | undefined;

    [key: string]: any;
}

export class DigitizedFolder implements IDigitizedFolder {
    attributes?: FolderAttribute[] | undefined;
    id?: string | undefined;
    version?: number | undefined;
    versionEndUser?: string | undefined;
    versionBranch?: string | undefined;
    versionTime?: Date | undefined;
    digitalFolderCode?: string | undefined;
    versionEndUserName?: string | undefined;
    configurationItem?: string | undefined;
    configurationItemName?: string | undefined;
    configurationSubItem?: string | undefined;
    configurationSubItemName?: string | undefined;
    product?: string | undefined;
    subSystemId?: string | undefined;
    metadata?: string | undefined;
    customerName?: string | undefined;
    status?: string | undefined;
    statusTime?: Date | undefined;
    digitizationStatus?: string | undefined;
    digitizationStatusTime?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    creationDate?: Date | undefined;
    comments?: string | undefined;
    digitalDocumentsInfo?: DigitalDocumentInfo[] | undefined;
    customer?: number | undefined;
    additionalCustomers?: number[] | undefined;
    account?: string | undefined;
    contract?: string | undefined;

    [key: string]: any;

    constructor(data?: IDigitizedFolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(FolderAttribute.fromJS(item));
            }
            this.id = _data["id"];
            this.version = _data["version"];
            this.versionEndUser = _data["versionEndUser"];
            this.versionBranch = _data["versionBranch"];
            this.versionTime = _data["versionTime"] ? new Date(_data["versionTime"].toString()) : <any>undefined;
            this.digitalFolderCode = _data["digitalFolderCode"];
            this.versionEndUserName = _data["versionEndUserName"];
            this.configurationItem = _data["configurationItem"];
            this.configurationItemName = _data["configurationItemName"];
            this.configurationSubItem = _data["configurationSubItem"];
            this.configurationSubItemName = _data["configurationSubItemName"];
            this.product = _data["product"];
            this.subSystemId = _data["subSystemId"];
            this.metadata = _data["metadata"];
            this.customerName = _data["customerName"];
            this.status = _data["status"];
            this.statusTime = _data["statusTime"] ? new Date(_data["statusTime"].toString()) : <any>undefined;
            this.digitizationStatus = _data["digitizationStatus"];
            this.digitizationStatusTime = _data["digitizationStatusTime"] ? new Date(_data["digitizationStatusTime"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            if (Array.isArray(_data["digitalDocumentsInfo"])) {
                this.digitalDocumentsInfo = [] as any;
                for (let item of _data["digitalDocumentsInfo"])
                    this.digitalDocumentsInfo!.push(DigitalDocumentInfo.fromJS(item));
            }
            this.customer = _data["customer"];
            if (Array.isArray(_data["additionalCustomers"])) {
                this.additionalCustomers = [] as any;
                for (let item of _data["additionalCustomers"])
                    this.additionalCustomers!.push(item);
            }
            this.account = _data["account"];
            this.contract = _data["contract"];
        }
    }

    static fromJS(data: any): DigitizedFolder {
        data = typeof data === 'object' ? data : {};
        let result = new DigitizedFolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["version"] = this.version;
        data["versionEndUser"] = this.versionEndUser;
        data["versionBranch"] = this.versionBranch;
        data["versionTime"] = this.versionTime ? this.versionTime.toISOString() : <any>undefined;
        data["digitalFolderCode"] = this.digitalFolderCode;
        data["versionEndUserName"] = this.versionEndUserName;
        data["configurationItem"] = this.configurationItem;
        data["configurationItemName"] = this.configurationItemName;
        data["configurationSubItem"] = this.configurationSubItem;
        data["configurationSubItemName"] = this.configurationSubItemName;
        data["product"] = this.product;
        data["subSystemId"] = this.subSystemId;
        data["metadata"] = this.metadata;
        data["customerName"] = this.customerName;
        data["status"] = this.status;
        data["statusTime"] = this.statusTime ? this.statusTime.toISOString() : <any>undefined;
        data["digitizationStatus"] = this.digitizationStatus;
        data["digitizationStatusTime"] = this.digitizationStatusTime ? this.digitizationStatusTime.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        if (Array.isArray(this.digitalDocumentsInfo)) {
            data["digitalDocumentsInfo"] = [];
            for (let item of this.digitalDocumentsInfo)
                data["digitalDocumentsInfo"].push(item.toJSON());
        }
        data["customer"] = this.customer;
        if (Array.isArray(this.additionalCustomers)) {
            data["additionalCustomers"] = [];
            for (let item of this.additionalCustomers)
                data["additionalCustomers"].push(item);
        }
        data["account"] = this.account;
        data["contract"] = this.contract;
        return data;
    }
}

export interface IDigitizedFolder {
    attributes?: FolderAttribute[] | undefined;
    id?: string | undefined;
    version?: number | undefined;
    versionEndUser?: string | undefined;
    versionBranch?: string | undefined;
    versionTime?: Date | undefined;
    digitalFolderCode?: string | undefined;
    versionEndUserName?: string | undefined;
    configurationItem?: string | undefined;
    configurationItemName?: string | undefined;
    configurationSubItem?: string | undefined;
    configurationSubItemName?: string | undefined;
    product?: string | undefined;
    subSystemId?: string | undefined;
    metadata?: string | undefined;
    customerName?: string | undefined;
    status?: string | undefined;
    statusTime?: Date | undefined;
    digitizationStatus?: string | undefined;
    digitizationStatusTime?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    creationDate?: Date | undefined;
    comments?: string | undefined;
    digitalDocumentsInfo?: DigitalDocumentInfo[] | undefined;
    customer?: number | undefined;
    additionalCustomers?: number[] | undefined;
    account?: string | undefined;
    contract?: string | undefined;

    [key: string]: any;
}

export class Document implements IDocument {
    id?: string | undefined;
    category?: DocumentCategory | undefined;
    userId?: string | undefined;
    issueDate?: Date | undefined;
    valid?: boolean | undefined;
    expirationDate?: Date | undefined;
    status?: DocumentStatus;
    dateCreated?: Date | undefined;
    dateUpdated?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.userId = _data["userId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.valid = _data["valid"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["userId"] = this.userId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["valid"] = this.valid;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IDocument {
    id?: string | undefined;
    category?: DocumentCategory | undefined;
    userId?: string | undefined;
    issueDate?: Date | undefined;
    valid?: boolean | undefined;
    expirationDate?: Date | undefined;
    status?: DocumentStatus;
    dateCreated?: Date | undefined;
    dateUpdated?: Date | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
}

export enum DocumentCategory {
    ProofOfPurchase = "ProofOfPurchase",
    AntiAuctionPeriodExpirationCertificate = "AntiAuctionPeriodExpirationCertificate",
    BrokerageAgreement = "BrokerageAgreement",
    CadastralMap = "CadastralMap",
    TopographicChart = "TopographicChart",
    HorizontalOwnership = "HorizontalOwnership",
    VerticalOwnership = "VerticalOwnership",
    PercentageTable = "PercentageTable",
    EnergyPerformanceCertificate = "EnergyPerformanceCertificate",
    BuildingPermit = "BuildingPermit",
    LegalReport = "LegalReport",
    AuditReport = "AuditReport",
    PreapprovalMemorandum = "PreapprovalMemorandum",
    AssessmentReport = "AssessmentReport",
    IdCard = "IdCard",
    Passport = "Passport",
    ResidencePermit = "ResidencePermit",
    GreekDescentIdCard = "GreekDescentIdCard",
    PowerOfAttorney = "PowerOfAttorney",
    AuctionParticipationOrder = "AuctionParticipationOrder",
    PropertyAuctionReport = "PropertyAuctionReport",
    FirstEngineerSignedStatement = "FirstEngineerSignedStatement",
    SecondEngineerSignedStatement = "SecondEngineerSignedStatement",
    TechnoeconomicStudy = "TechnoeconomicStudy",
    LegalAudit = "LegalAudit",
    EngineerLegitimacyCertificate = "EngineerLegitimacyCertificate",
    PropertyElectronicIdentity = "PropertyElectronicIdentity",
    ArbitrarySettlementStatement = "ArbitrarySettlementStatement",
    ValidationReport = "ValidationReport",
    PurchaseContract = "PurchaseContract",
    Offer = "Offer",
    LetterOfIntent = "LetterOfIntent",
    OtherDocuments = "OtherDocuments",
    OtherLegalDocuments = "OtherLegalDocuments",
    OtherTechnicalDocuments = "OtherTechnicalDocuments",
    Photos = "Photos",
}

export class DocumentDeleteMetadataRequest implements IDocumentDeleteMetadataRequest {
    propertiesToDelete?: DocumentProperty[] | undefined;

    constructor(data?: IDocumentDeleteMetadataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["propertiesToDelete"])) {
                this.propertiesToDelete = [] as any;
                for (let item of _data["propertiesToDelete"])
                    this.propertiesToDelete!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentDeleteMetadataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDeleteMetadataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.propertiesToDelete)) {
            data["propertiesToDelete"] = [];
            for (let item of this.propertiesToDelete)
                data["propertiesToDelete"].push(item);
        }
        return data;
    }
}

export interface IDocumentDeleteMetadataRequest {
    propertiesToDelete?: DocumentProperty[] | undefined;
}

export enum DocumentProperty {
    UserId = "UserId",
    CustomerTaxCode = "CustomerTaxCode",
    PropertyCode = "PropertyCode",
    Status = "Status",
    PropertyId = "PropertyId",
    PropertyRn = "PropertyRn",
    Kaek = "Kaek",
    PropertyType = "PropertyType",
    StreetName = "StreetName",
    StreetNumber = "StreetNumber",
    City = "City",
    PostalCode = "PostalCode",
    SdenApplicationNo = "SdenApplicationNo",
    LoanAggreementNo = "LoanAggreementNo",
    AlmaNo = "AlmaNo",
    ForEngineer = "ForEngineer",
    ForLawyer = "ForLawyer",
    IsActive = "IsActive",
    WritingYear = "WritingYear",
    IssueDate = "IssueDate",
    IssueDateFrom = "IssueDateFrom",
    IssueDateTo = "IssueDateTo",
    CustomerFullName = "CustomerFullName",
    Comment = "Comment",
    CreatedBy = "CreatedBy",
    UpdatedBy = "UpdatedBy",
}

export class DocumentResultSet implements IDocumentResultSet {
    count?: number;
    items?: Document[] | undefined;

    constructor(data?: IDocumentResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentResultSet {
    count?: number;
    items?: Document[] | undefined;
}

export enum DocumentStatus {
    Valid = "Valid",
    Invalid = "Invalid",
    Draft = "Draft",
    Deleted = "Deleted",
}

export class DocumentUpdateFileRequest implements IDocumentUpdateFileRequest {
    file?: string | undefined;

    constructor(data?: IDocumentUpdateFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): DocumentUpdateFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUpdateFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file;
        return data;
    }
}

export interface IDocumentUpdateFileRequest {
    file?: string | undefined;
}

export class DocumentUploadFileRequest implements IDocumentUploadFileRequest {
    userId?: string | undefined;
    customerTaxCode?: string | undefined;
    relatedPropertyCode?: string | undefined;
    relatedPropertyId?: string | undefined;
    relatedPropertyRn?: string | undefined;
    kaek?: number | undefined;
    relatedPropertyType?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    sdenApplicationNo?: string | undefined;
    loanAggreementNo?: string | undefined;
    almaNo?: string | undefined;
    forLawyer?: boolean | undefined;
    forEngineer?: boolean | undefined;
    isActive?: boolean | undefined;
    writingYear?: number | undefined;
    issueDate?: Date | undefined;
    customerFullName?: string | undefined;
    comment?: string | undefined;
    status?: DocumentStatus | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    category?: DocumentCategory;
    file?: string | undefined;

    constructor(data?: IDocumentUploadFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.customerTaxCode = _data["customerTaxCode"];
            this.relatedPropertyCode = _data["relatedPropertyCode"];
            this.relatedPropertyId = _data["relatedPropertyId"];
            this.relatedPropertyRn = _data["relatedPropertyRn"];
            this.kaek = _data["kaek"];
            this.relatedPropertyType = _data["relatedPropertyType"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.sdenApplicationNo = _data["sdenApplicationNo"];
            this.loanAggreementNo = _data["loanAggreementNo"];
            this.almaNo = _data["almaNo"];
            this.forLawyer = _data["forLawyer"];
            this.forEngineer = _data["forEngineer"];
            this.isActive = _data["isActive"];
            this.writingYear = _data["writingYear"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>undefined;
            this.customerFullName = _data["customerFullName"];
            this.comment = _data["comment"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.category = _data["category"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): DocumentUploadFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentUploadFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["customerTaxCode"] = this.customerTaxCode;
        data["relatedPropertyCode"] = this.relatedPropertyCode;
        data["relatedPropertyId"] = this.relatedPropertyId;
        data["relatedPropertyRn"] = this.relatedPropertyRn;
        data["kaek"] = this.kaek;
        data["relatedPropertyType"] = this.relatedPropertyType;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["sdenApplicationNo"] = this.sdenApplicationNo;
        data["loanAggreementNo"] = this.loanAggreementNo;
        data["almaNo"] = this.almaNo;
        data["forLawyer"] = this.forLawyer;
        data["forEngineer"] = this.forEngineer;
        data["isActive"] = this.isActive;
        data["writingYear"] = this.writingYear;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["customerFullName"] = this.customerFullName;
        data["comment"] = this.comment;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["category"] = this.category;
        data["file"] = this.file;
        return data;
    }
}

export interface IDocumentUploadFileRequest {
    userId?: string | undefined;
    customerTaxCode?: string | undefined;
    relatedPropertyCode?: string | undefined;
    relatedPropertyId?: string | undefined;
    relatedPropertyRn?: string | undefined;
    kaek?: number | undefined;
    relatedPropertyType?: string | undefined;
    streetName?: string | undefined;
    streetNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    sdenApplicationNo?: string | undefined;
    loanAggreementNo?: string | undefined;
    almaNo?: string | undefined;
    forLawyer?: boolean | undefined;
    forEngineer?: boolean | undefined;
    isActive?: boolean | undefined;
    writingYear?: number | undefined;
    issueDate?: Date | undefined;
    customerFullName?: string | undefined;
    comment?: string | undefined;
    status?: DocumentStatus | undefined;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    category?: DocumentCategory;
    file?: string | undefined;
}

export class FolderAttribute implements IFolderAttribute {
    id?: string | undefined;
    values?: DigitalFolderAttributeValues | undefined;
    attributeTypeId?: string;
    attributeTypeName?: string | undefined;
    grouping?: string | undefined;
    ordering?: number | undefined;
    version?: number | undefined;
    versionEndUser?: string | undefined;
    versionBranch?: string | undefined;
    versionTime?: Date | undefined;

    [key: string]: any;

    constructor(data?: IFolderAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.values = _data["values"] ? DigitalFolderAttributeValues.fromJS(_data["values"]) : <any>undefined;
            this.attributeTypeId = _data["attributeTypeId"];
            this.attributeTypeName = _data["attributeTypeName"];
            this.grouping = _data["grouping"];
            this.ordering = _data["ordering"];
            this.version = _data["version"];
            this.versionEndUser = _data["versionEndUser"];
            this.versionBranch = _data["versionBranch"];
            this.versionTime = _data["versionTime"] ? new Date(_data["versionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FolderAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new FolderAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["values"] = this.values ? this.values.toJSON() : <any>undefined;
        data["attributeTypeId"] = this.attributeTypeId;
        data["attributeTypeName"] = this.attributeTypeName;
        data["grouping"] = this.grouping;
        data["ordering"] = this.ordering;
        data["version"] = this.version;
        data["versionEndUser"] = this.versionEndUser;
        data["versionBranch"] = this.versionBranch;
        data["versionTime"] = this.versionTime ? this.versionTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFolderAttribute {
    id?: string | undefined;
    values?: DigitalFolderAttributeValues | undefined;
    attributeTypeId?: string;
    attributeTypeName?: string | undefined;
    grouping?: string | undefined;
    ordering?: number | undefined;
    version?: number | undefined;
    versionEndUser?: string | undefined;
    versionBranch?: string | undefined;
    versionTime?: Date | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class SearchFolderResponse implements ISearchFolderResponse {
    folder?: DigitizedFolder | undefined;
    folderId?: string | undefined;

    constructor(data?: ISearchFolderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folder = _data["folder"] ? DigitizedFolder.fromJS(_data["folder"]) : <any>undefined;
            this.folderId = _data["folderId"];
        }
    }

    static fromJS(data: any): SearchFolderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchFolderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folder"] = this.folder ? this.folder.toJSON() : <any>undefined;
        data["folderId"] = this.folderId;
        return data;
    }
}

export interface ISearchFolderResponse {
    folder?: DigitizedFolder | undefined;
    folderId?: string | undefined;
}

export class ServiceDocument implements IServiceDocument {
    category?: DocumentCategory;
    hasValidityPeriod?: boolean | undefined;

    constructor(data?: IServiceDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.hasValidityPeriod = _data["hasValidityPeriod"];
        }
    }

    static fromJS(data: any): ServiceDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["hasValidityPeriod"] = this.hasValidityPeriod;
        return data;
    }
}

export interface IServiceDocument {
    category?: DocumentCategory;
    hasValidityPeriod?: boolean | undefined;
}

export class ServiceDocumentsResponse implements IServiceDocumentsResponse {
    serviceType?: ServiceType;
    mandatoryInputs?: ServiceDocument[] | undefined;
    optionalInputs?: ServiceDocument[] | undefined;
    outputs?: ServiceDocument[] | undefined;
    templates?: ServiceDocument[] | undefined;
    forEngineerConfig?: BooleanMetadataConfig | undefined;
    forLawyerConfig?: BooleanMetadataConfig | undefined;

    constructor(data?: IServiceDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceType = _data["serviceType"];
            if (Array.isArray(_data["mandatoryInputs"])) {
                this.mandatoryInputs = [] as any;
                for (let item of _data["mandatoryInputs"])
                    this.mandatoryInputs!.push(ServiceDocument.fromJS(item));
            }
            if (Array.isArray(_data["optionalInputs"])) {
                this.optionalInputs = [] as any;
                for (let item of _data["optionalInputs"])
                    this.optionalInputs!.push(ServiceDocument.fromJS(item));
            }
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(ServiceDocument.fromJS(item));
            }
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(ServiceDocument.fromJS(item));
            }
            this.forEngineerConfig = _data["forEngineerConfig"] ? BooleanMetadataConfig.fromJS(_data["forEngineerConfig"]) : <any>undefined;
            this.forLawyerConfig = _data["forLawyerConfig"] ? BooleanMetadataConfig.fromJS(_data["forLawyerConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceType"] = this.serviceType;
        if (Array.isArray(this.mandatoryInputs)) {
            data["mandatoryInputs"] = [];
            for (let item of this.mandatoryInputs)
                data["mandatoryInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.optionalInputs)) {
            data["optionalInputs"] = [];
            for (let item of this.optionalInputs)
                data["optionalInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item.toJSON());
        }
        data["forEngineerConfig"] = this.forEngineerConfig ? this.forEngineerConfig.toJSON() : <any>undefined;
        data["forLawyerConfig"] = this.forLawyerConfig ? this.forLawyerConfig.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceDocumentsResponse {
    serviceType?: ServiceType;
    mandatoryInputs?: ServiceDocument[] | undefined;
    optionalInputs?: ServiceDocument[] | undefined;
    outputs?: ServiceDocument[] | undefined;
    templates?: ServiceDocument[] | undefined;
    forEngineerConfig?: BooleanMetadataConfig | undefined;
    forLawyerConfig?: BooleanMetadataConfig | undefined;
}

export enum ServiceType {
    AssetOnboarding = "AssetOnboarding",
    PreApprovalAssessment = "PreApprovalAssessment",
    PropertyWalkthrough = "PropertyWalkthrough",
    AuctionBiddingSupport = "AuctionBiddingSupport",
    LegalReport = "LegalReport",
    TechnicalReport = "TechnicalReport",
    MaturityServices = "MaturityServices",
    AuctionAssetOnboarding = "AuctionAssetOnboarding",
    PropertyFileConstitution = "PropertyFileConstitution",
    ContractSupport = "ContractSupport",
    Moving = "Moving",
    Renovation = "Renovation",
    Cleaning = "Cleaning",
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
export interface FileParameter {
    data: any;
    fileName: string;
}